// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"5909ea3b","350":"f115945b"}[chunkId] + ".chunk.js";
};